module.exports = __webpack_public_path__ + "img/t2-2.12b1939d.svg";